<template>
<default-layout :data="data" section="contact">
  <template slot-scope="slotProps">
  <div class="contact-container">
    <contact-header :data="headerData" />
    <contact-map :data="mapData" />
    <contact-form />
   <!--<image-text-column :data="imageData" /> -->
    <particle-hiring :data="hiringData" />
  </div>
  </template>
</default-layout>
</template>

<script>
// Components
import DefaultLayout from '@/layouts/default';
import ContactForm from '@/modules/contact/ContactUsForm';
import ContactHeader from '@/modules/contact/ContactHeader';
import ContactMap from '@/modules/contact/ContactMap';
import ImageTextColumn from '@/modules/work/ImageTextColumn';
import ParticleHiring from '@/modules/about/ParticleHiring';

export default {

  name: 'ContactMain',

  metaInfo: {
    title: 'Contact - Particle Design',
  },

  components: {
    DefaultLayout,
    ContactForm,
    ContactHeader,
    ContactMap,
    ImageTextColumn,
    ParticleHiring,
  },

  props: ['data'],

  computed: {

    headerData() {
      const { data } = this;
      return data.headerData;
    },

    hiringData() {
      const { data } = this;
      return data.hiringData;
    },

    imageData() {
      const { data } = this;
      return data.imageData;
    },

    mapData() {
      const { data } = this;
      return data.mapData;
    },

  },
};
</script>


<style lang="scss">
@import '../styles/main.scss';
@import '../styles/_typography.scss';
@import '../styles/_mixins.scss';

.section-contact {

  /*
    this section handles "extended-desktop" mode
    it should be on all "core" pages
  */
  main {
    width: 100%;
    display: grid;
    grid-template-columns: 0 100vw 0;

    @include ngMq($layout--max-content-width, up) {
      grid-template-columns: 1fr $layout--max-content-width 1fr;
    }

    .contact-container {
      grid-column: 2 / span 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ContactMain.vue